module.exports = __webpack_public_path__ + "static/media/sygnet_dr_dabrowska.6c91e624.jpg";